__turbopack_context__.v({
  "btn": "styles-module__OY2bxG__btn",
  "container": "styles-module__OY2bxG__container",
  "pagePadding": "styles-module__OY2bxG__pagePadding",
  "slide": "styles-module__OY2bxG__slide",
  "slider": "styles-module__OY2bxG__slider",
  "sliderContainer": "styles-module__OY2bxG__sliderContainer",
});
